module.exports = __webpack_public_path__ + "static/media/verification.d498a9b3.png";